// TIP-518 — redesigned home hero.
// Navy gradient canvas, locked copy ("List. Belong. Grow."), and the
// existing Search component rendered in its hero variant so all search
// functionality (country dropdown, GPS, validation, navigation) is reused.
import React, { useEffect } from "react";
import Search from "../../Search";
import { useGetUserQuery } from "../../../../store/auth/usersApiSlice";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo } from "../../../../store/auth/authSlice";

const HeroBackdrop = () => (
  <div aria-hidden="true" className="hero-backdrop">
    <div className="hero-backdrop-glow" />
    <svg className="hero-backdrop-gem-1" width="440" height="440" viewBox="0 0 49 52">
      <path d="M28.97 35.30H24.27V51.99L48.22 28.01C40.30 27.03 33.14 26.60 26.81 26.52L28.97 35.29Z" fill="var(--gold)" />
      <path d="M0.31 23.99C5.08 24.85 12.37 25.80 21.88 25.96L21.99 25.49C20.55 24.69 19.58 23.15 19.58 21.39C19.58 18.79 21.68 16.68 24.27 16.68V0" fill="var(--gold)" />
      <path d="M24.28 51.99V35.31H19.58L21.73 26.56C12.59 26.72 5.51 27.62 0.77 28.46L16.18 34.12L24.28 52.00Z" fill="var(--coral)" />
      <path d="M28.97 21.39C28.97 23.16 28.00 24.70 26.55 25.50L26.67 25.99C33.16 25.92 40.52 25.48 48.68 24.44L32.37 17.88L24.27 0V16.69C26.86 16.69 28.97 18.80 28.97 21.39Z" fill="var(--coral)" />
    </svg>
    <svg className="hero-backdrop-gem-2" width="320" height="320" viewBox="0 0 49 52">
      <path d="M28.97 35.30H24.27V51.99L48.22 28.01C40.30 27.03 33.14 26.60 26.81 26.52L28.97 35.29Z" fill="#fff" />
      <path d="M0.31 23.99C5.08 24.85 12.37 25.80 21.88 25.96L21.99 25.49C20.55 24.69 19.58 23.15 19.58 21.39C19.58 18.79 21.68 16.68 24.27 16.68V0" fill="#fff" />
    </svg>
  </div>
);

const HeroSection = () => {
  const dispatch = useDispatch();
  const { token, userInfo } = useSelector((state) => state.auth);
  const { data, isSuccess } = useGetUserQuery(token, {
    skip: !token && !userInfo,
  });

  useEffect(() => {
    if (isSuccess) {
      dispatch(setUserInfo({ ...data }));
    }
  }, [data, dispatch, isSuccess]);

  return (

    <section data-component="Banner" className="hero-section">
      <HeroBackdrop />
      <div className="container-wide" style={{ position: "relative", paddingTop: 96, paddingBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 26 }}>
          <span className="hero-eyebrow">
            <span className="dot" />
            The UAE Business Directory
          </span>
        </div>
        <h1 className="hero-headline">
          List<span className="period">.</span>Belong<span className="period">.</span>Grow<span className="period">.</span>
        </h1>
        <p className="hero-sub">
          <b>Free to list. Free to claim.</b> The directory every UAE business belongs on.
        </p>
        {/* TIP-568 — SEO intro line, supporting copy alongside the locked hero headline/sub above */}
        <p className="hero-seo-intro">
          TREVEX is the UAE business directory. Search UAE businesses by name, sector, and emirate, or list your business free.
        </p>

        <Search variant="hero" />
      </div>
    </section>
  )
};

export default HeroSection;
